import { render, staticRenderFns } from "./trust-magazine-form-panel.vue?vue&type=template&id=ba29a0a8&"
var script = {}
import style0 from "../../../assets/styles/controls/Forms/_TrustMagazineForm.scss?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports